import produce from 'immer';

export type FreeResponses = {
  id: string;
  templateType: 'free_responses';
  question: {
    update: (html: string) => void;
    text: string;
  };
};

export default function freeResponse({ item, distractors, setItem }): FreeResponses {
  const anchor = item.facets[0]?.anchor;

  const update = (html) => {
    distractors.update({
      pathParams: { id: anchor?.id },
      data: { data: { attributes: { 'text-html': String(html) } } },
    });
    setItem((prevItem) =>
      produce(prevItem, (draft) => {
        draft.question.text = String(html);
      })
    );
  };

  return {
    id: item.id,
    templateType: 'free_responses',
    question: {
      update,
      text: anchor?.textHtml,
    },
  };
}
